import { render, staticRenderFns } from "./CreateAssessment.vue?vue&type=template&id=32cc1718"
import script from "./CreateAssessment.vue?vue&type=script&lang=js"
export * from "./CreateAssessment.vue?vue&type=script&lang=js"
import style0 from "./CreateAssessment.vue?vue&type=style&index=0&id=32cc1718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports